function Footer(){
    return(
        <footer class="footer mt-lg-2 mt-4 py-lg-3 p-1 fixed-bottom text-center">
        
         <span>© 2025 QP To Marks Calculator. All rights reserved. | Designed with ❤️ by <strong> <a href="https://bykhizershafi.vercel.app/"> Khizer Shafi</a> </strong></span>
     
    </footer>
    )
};

export default Footer;
